import * as R from 'ramda';
// helpers
import { isArray } from './helpers';
//////////////////////////////////////////////////

const stringIncludesFilterValue = (data, filterValue) => {
  if (isArray(data)) {
    return R.any(
      (str) => R.includes(R.toLower(filterValue || ''), R.toLower(str || '')),
      data,
    );
  }

  return R.includes(R.toLower(filterValue || ''), R.toLower(data || ''));
};

export {
  stringIncludesFilterValue,
};
